import {http} from '@/utils/http'
import {IFilter} from "@/types/main";
import {cleanParams} from "@/utils/cleanParams";

export const errorService = {
    getErrors(filter: IFilter) {
        return http.get('/errors', {
            params: cleanParams(filter)
        })
    },
}